export default function Checkmark({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.1164 9.32218L0.355469 5.56125L1.43312 4.4836L4.1164 7.16689L10.9278 0.355469L12.0055 1.43312L4.1164 9.32218Z"
        fill="currentColor"
      />
    </svg>
  );
}
